import React from 'react';

import { useStyledTheme } from 'hooks/useStyledTheme';

import SvgIcon from '../SvgIcon';

const IconTelephoneMeetings = (props: React.SVGAttributes<SVGSVGElement>) => {
  const theme = useStyledTheme();

  return (
    <SvgIcon viewBox="0 0 535.9 496.9" {...props}>
      <path fill="#e5ebed" d="M8.9 82.9h513v296H8.9z" />
      <path fill="#c2d2da" d="M523.9 379.9H7.9v-299h516v299zm-513-3h510v-293h-510v293z" />
      <path fill="#fff" d="M230.9 15.9h-175v138h107l30.8 30.8-.2-30.8h37.4z" />
      <path
        fill={theme.colors.fountainBlue}
        d="M195.2 187.9l-33-33H54.9v-141h178v141H195l.2 33zm-137.3-36h105.7l28.7 28.7-.2-28.7h37.8v-135h-172v135z"
      />
      <g fill="#c2d2da">
        <circle cx="113" cy="83.1" r="8.7" />
        <circle cx="144.3" cy="83.1" r="8.7" />
        <circle cx="175.7" cy="83.1" r="8.7" />
        <circle cx="78.1" cy="226.7" r="21.8" />
        <circle cx="78.1" cy="300.4" r="21.8" />
      </g>
      <path fill="#dee9ef" d="M297.9 109.9h187v302h-187z" />
      <path
        fill={theme.colors.fountainBlue}
        d="M486.9 412.9h-190v-305h190v305zm-187-3h184v-299h-184v299z"
      />
      <path fill="#fff" d="M265.9 137.9h187v302h-187z" />
      <g fill={theme.colors.accent}>
        <path d="M454.9 440.9h-190v-305h190v305zm-187-3h184v-299h-184v299z" />
        <path d="M436.9 385.9h-155v-215h155v215zm-152-3h149v-209h-149v209zM344.1 152.4h31v3h-31z" />
        <path d="M359.4 423.9c-6.6 0-11.9-5.3-11.9-11.9 0-6.6 5.3-11.9 11.9-11.9s11.9 5.3 11.9 11.9c0 6.6-5.4 11.9-11.9 11.9zm0-20.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-4-8.9-8.9-8.9z" />
      </g>
      <g fill="#e5ebed">
        <path d="M75.4 236.2L65.1 227l2-2.2 8.2 7.3 13.7-14 2.2 2.1z" />
        <path d="M75.4 310l-10.3-9.2 2-2.2 8.2 7.3 13.7-14 2.2 2.1z" />
        <ellipse cx="360.8" cy="475.9" rx="92.5" ry="6" />
      </g>
      <path d="M124.5 219.2h106.8v15H124.5zm0 74.7h106.8v15H124.5z" fill="#dae4e7" />
      <circle fill="#fff" cx="464.4" cy="114.9" r="47.8" />
      <path
        fill={theme.colors.fountainBlue}
        d="M464.4 164.2c-27.2 0-49.3-22.1-49.3-49.3 0-27.2 22.1-49.3 49.3-49.3s49.3 22.1 49.3 49.3c-.1 27.2-22.2 49.3-49.3 49.3zm0-95.6c-25.5 0-46.3 20.8-46.3 46.3s20.8 46.3 46.3 46.3 46.3-20.8 46.3-46.3-20.8-46.3-46.3-46.3z"
      />
      <path
        fill="#fff"
        d="M464.4 123.8c-8.8 0-16-7.2-16-16v-7.6c0-8.8 7.2-16 16-16s16 7.2 16 16v7.6c0 8.8-7.2 16-16 16z"
      />
      <path
        fill={theme.colors.fountainBlue}
        d="M464.4 125.3c-9.6 0-17.5-7.8-17.5-17.5v-7.6c0-9.6 7.8-17.5 17.5-17.5s17.5 7.8 17.5 17.5v7.6c0 9.6-7.9 17.5-17.5 17.5zm0-39.6c-8 0-14.5 6.5-14.5 14.5v7.6c0 8 6.5 14.5 14.5 14.5s14.5-6.5 14.5-14.5v-7.6c0-8-6.5-14.5-14.5-14.5z"
      />
      <path fill="#fff" d="M448.4 100.2S469 104 469 93.7c0 10.3 11.4 8 11.4 8" />
      <path
        fill={theme.colors.fountainBlue}
        d="M477.8 103.4c-2.1 0-5-.4-7.3-2.2-.8-.7-1.5-1.5-2-2.5l-.7.7c-5.7 4.7-19.1 2.3-19.7 2.2l.5-2.9c3.5.6 13.4 1.6 17.3-1.6 1-.9 1.5-2 1.5-3.4h3c0 2.4.7 4.1 2 5.2 2.7 2.2 7.6 1.4 7.6 1.4l.6 2.9c-.1 0-1.2.2-2.8.2zM431.2 151.2c-.3-4.5 1.7-10.6 12.9-13.4 6.7-1.7 12.6-8.1 12.6-13.8h3c0 7-6.8 14.7-14.8 16.7-7.4 1.8-11 5.3-10.7 10.3l-3 .2zm66.4 0l-3-.2c.3-5-3.3-8.4-10.7-10.3-8-2-14.8-9.7-14.8-16.7h3c0 5.7 5.9 12.1 12.6 13.8 11.1 2.8 13.1 8.8 12.9 13.4zM470.4 161.5l-4.3-23.3h-3.5l-4.3 23.3-3-.6 4.8-25.7h8.5l4.8 25.7z"
      />
    </SvgIcon>
  );
};

export default IconTelephoneMeetings;
